export const UPLOAD_STATUS = {
	UPLOADING: 0,
	SUCCESS: 1,
	FAILED: 2,
};
